import { makeStyles } from '@mui/styles';
import { neutral7 } from 'apollo-react/colors';
import React from 'react';

import { useTranslation } from '../../custom-hooks/useTranslation';
import { REPORT_CONTROL_TYPE } from '../constants/report-designer.constants';
import { isExpressionValue } from '../utils/report-designer.utils';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    justifyContent: 'center',
    padding: 10,
    border: `1px solid ${neutral7}`,
    borderRadius: 5,
  },
});

const SSReportText = ({ controlType, reportTitle = '', displayText = '' }) => {
  const classes = useStyles();
  const translateString = useTranslation();

  const isPageHeader = controlType === REPORT_CONTROL_TYPE.PAGE_HEADER;
  const text = isPageHeader ? reportTitle : displayText;

  const titleToDisplay = !text.length
    ? `${translateString('Page')} ${
        isPageHeader ? translateString('Header') : translateString('Footer')
      } ${translateString('text')} ...`
    : isExpressionValue(text)
    ? translateString('Expression')
    : text;

  return (
    <div className={classes.root}>
      <span>{titleToDisplay}</span>
    </div>
  );
};

export default SSReportText;
